import { TextField, styled } from "@mui/material";

const CustomInputLabel = styled('label')({
    '& .last-char': {
      color: 'red', // Son karakterin rengi
    },
  })
  
  const CustomTextField = ({ label, ...props }:any) => {
    const styledLabel = (
      <CustomInputLabel>
        {label.slice(0, -1)}
        <span className="last-char">{label.slice(-1)}</span>
      </CustomInputLabel>
    );
  
    return (
      <TextField
        {...props}
        label={styledLabel}
        InputLabelProps={{
          shrink: true,
        }}
      />
    );
  };
  export default CustomTextField
 